import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Calendar, Target, TrendingUp, Award } from 'lucide-react';
import ProgramPageLayout from '../../components/shared/ProgramPageLayout';

const PremiumMentorship: React.FC = () => {
  return (
    <ProgramPageLayout slug="mentorship" theme="purple">
      {(program) => (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Program Features</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {program.features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
                className="flex items-start space-x-4 p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
              >
                <div className="flex-shrink-0">
                  <CheckCircle className="h-6 w-6 text-purple-500" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">{feature}</h3>
                  <p className="text-gray-600 text-sm">
                    Comprehensive {feature.toLowerCase()} with expert mentorship guidance.
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Mentorship Benefits */}
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-8 mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Our Mentorship Program?</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-3">
                <Target className="h-6 w-6 text-purple-600 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Personalized Guidance</h4>
                  <p className="text-gray-600 text-sm">One-on-one mentorship tailored to your specific goals and challenges.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <TrendingUp className="h-6 w-6 text-purple-600 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Accelerated Growth</h4>
                  <p className="text-gray-600 text-sm">Fast-track your career with industry insights and proven strategies.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Award className="h-6 w-6 text-purple-600 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Expert Network</h4>
                  <p className="text-gray-600 text-sm">Connect with successful professionals and industry leaders.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Calendar className="h-6 w-6 text-purple-600 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Flexible Schedule</h4>
                  <p className="text-gray-600 text-sm">Sessions scheduled around your availability and commitments.</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </ProgramPageLayout>
  );
};

export default PremiumMentorship;
